/**
 * "1 match", "2 matches": count with the right word form.
 */
export function pluralize(count, singular, plural = `${singular}s`) {
    return `${count} ${count === 1 ? singular : plural}`;
}

/**
 * Count of cabinet items the viewer earned this season.
 * Shared by the awards page shelf and the Wrapped closing slide.
 */
export function countViewerTrophies(viewer) {
    if (!viewer) return 0;
    let count = 0;
    if (viewer.isChampion) count += 1;
    if (viewer.totwPicks > 0) count += 1;
    if (viewer.hasGoldenGlove) count += 1;
    return count;
}
